/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';

import HeaderView from '../HeaderView';
import ExternalFooterView from '../ExternalFooterView';
import InternalFooterView from '../InternalFooterView';

import './ScaffoldView.css';
import tmplScaffoldView from './ScaffoldView.hbs';

const ScaffoldView = View.extend({
  template: tmplScaffoldView,

  el: 'body',

  ui: {
    header: '#__header',
    content: '#__content',
    footer: '#__footer'
  },

  regions: {
    header: '@ui.header',
    content: '@ui.content',
    footer: '@ui.footer'
  },

  onRender() {
    if (EXTERNAL) {
      this.$el.addClass('external');
      this.showChildView('footer', new ExternalFooterView());
    } else {
      this.showChildView('footer', new InternalFooterView())
      this.$el.addClass('internal');
    }
    this.showChildView('header', new HeaderView());
    this.$el.addClass('d-flex');
    this.$el.addClass('flex-column');
  }
});

export default ScaffoldView;
